import api from "./Api";

class CompartilhamentoService {
  EnviarEmail(payload) {
    return api.post("/v1/compartilhamento/email", payload).then((response) => {
      return response.data;
    });
  }
  Whatsapp(payload) {
    return api
      .post("/v1/compartilhamento/whatsapp", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CompartilhamentoService();
